const s3_bucket_prefix = 'https://listingopen-photos.s3.us-east-2.amazonaws.com/';

export default function getIdFromPhotoUrl(url) {
	return url.replace(s3_bucket_prefix,'');
}